import React from 'react';
import { Linkedin, Award, TrendingUp } from 'lucide-react';
export const MeetIrina = () => {
  return <div className="py-20 bg-white" data-id="element-1287">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1288">
        <div className="text-center mb-12" data-id="element-1289">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1290">
            Meet Your Sales Expert
          </h2>
          <p className="text-xl text-gray-600" data-id="element-1291">
            Human expertise meets AI power
          </p>
        </div>
        <div className="max-w-6xl mx-auto" data-id="element-1292">
          <div className="bg-gradient-to-br from-[#6366f1]/5 to-[#d5ff00]/5 rounded-2xl p-8 md:p-12 border border-gray-200" data-id="element-1293">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1294">
              <div className="flex justify-center" data-id="element-1295">
                <div className="relative" data-id="element-1296">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uy5NWm7gwFbrAv2AbUN2KJ/irina_lam.jpg" alt="Irina Stoicescu" className="w-full h-[500px] rounded-2xl object-cover shadow-xl" data-id="element-1297" />
                  <a href="https://www.linkedin.com/in/irina-stoicescu/" target="_blank" rel="noopener noreferrer" className="absolute bottom-4 right-4 bg-[#0077B5] text-white p-3 rounded-full shadow-lg hover:bg-[#006399] transition-colors" data-id="element-1298">
                    <Linkedin size={24} data-id="element-1299" />
                  </a>
                </div>
              </div>
              <div data-id="element-1300">
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1301">
                  Irina Stoicescu
                </h3>
                <p className="text-lg text-[#6366f1] font-semibold mb-4" data-id="element-1302">
                  Founder & Lead Sales Strategist
                </p>
                <div className="space-y-4 mb-6" data-id="element-1303">
                  <div className="flex items-start gap-3" data-id="element-1304">
                    <Award className="w-5 h-5 text-[#6366f1] mt-1 flex-shrink-0" data-id="element-1305" />
                    <div data-id="element-1306">
                      <p className="font-semibold text-gray-900" data-id="element-1307">
                        17+ Years in B2B Sales
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-1308">
                        Deep expertise in outbound strategies and lead
                        generation
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1309">
                    <TrendingUp className="w-5 h-5 text-[#6366f1] mt-1 flex-shrink-0" data-id="element-1310" />
                    <div data-id="element-1311">
                      <p className="font-semibold text-gray-900" data-id="element-1312">
                        50+ Successful Projects
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-1313">
                        Scaled campaigns across industries and markets
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1314">
                    <Award className="w-5 h-5 text-[#6366f1] mt-1 flex-shrink-0" data-id="element-1315" />
                    <div data-id="element-1316">
                      <p className="font-semibold text-gray-900" data-id="element-1317">
                        Founder of Set-Sell.com
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-1318">
                        Leading B2B sales agency where Gigi was born
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 border border-gray-200" data-id="element-1319">
                  <p className="text-gray-700 italic" data-id="element-1320">
                    "I've spent nearly two decades perfecting B2B outreach. Now,
                    with AI, we can deliver that same expert-level
                    personalization at scale—but I still review every campaign
                    to ensure it meets my standards."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-1321">
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-1322">
            When you work with Gigi, you're not just getting AI
            automation—you're getting Irina's 17 years of sales expertise
            guiding every campaign decision.
          </p>
        </div>
      </div>
    </div>;
};